// add crisp segments - filterung in crisp

export default function crispSegments($domain) {
    $crisp.push(["set", "session:segments", [[$domain, "website"]]]);
}
